/**
 * The tracking.js script loads the different tracking providers and handles the embed overlay
 */
import $ from 'jquery';
import { clickOnly, isIframe } from './utils';
const $overlay = $('.iframe-overlay');

// this google analytics plugin needs jquery: https://scrolldepth.parsnip.io/
window.jQuery = $;

const config = ARTICLE_CONFIG;

function init() {
  if (!isIframe()) {
    return loadTracking(config);
  }

  $('html').addClass('is-embed-mode');
  $('html').addClass('is-embed-overlay');

  $overlay.on('click', loadTracking);
  clickOnly('.iframe-overlay');
}

function loadTracking() {
  $('html').removeClass('is-embed-overlay');
  $overlay.remove();

  if (!config.tracking.enabled) {
    return false;
  }
}

export default {
  init
};
